/* eslint-disable react/jsx-no-target-blank */

import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import IconFreska from 'assets/images/icon-freska.svg';
import IconIdea from 'assets/images/icon-idea.svg';

export const LoginLayout = ({
  t,
  title,
  description,
  showSignUp,
  children
}) => (
  <div className="layout--flex layout--full-height">
    <div className="layout__login">
      <div className="login">
        <img className="login__logo" alt="Freska" src={IconFreska} />

        <h1>{title}</h1>

        <p className="login__description">{description}</p>

        {children}

        {showSignUp && (
          <a className="box box--login box--simple" href="https://freska.fi">
            <h5>{t('login.signUp.heading')}</h5>
            <p className="no-margin">{t('login.signUp.description')}</p>
          </a>
        )}
      </div>

      <p className="login__copyright">Freska Finland Oy &copy; 2018</p>
    </div>

    <div className="layout__background-image">
      <div className="login__upsell">
        <img alt="Idea" src={IconIdea} />

        <h3>{t('login.upsell.heading')}</h3>

        <p>{t('login.upsell.description')}</p>

        <a
          className="button button--hollow"
          href="https://www.freska.fi/siivouslahjakortti"
          target="_blank"
        >
          {t('login.upsell.action')}
        </a>
      </div>
    </div>
  </div>
);

LoginLayout.propTypes = {
  t: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  showSignUp: PropTypes.bool,
  children: PropTypes.node.isRequired
};

LoginLayout.defaultProps = {
  showSignUp: true
};

export default translate()(LoginLayout);



// WEBPACK FOOTER //
// ./src/components/LoginLayout/LoginLayout.js